function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.051 10.8859L21.4318 1.50385C21.7628 1.17385 21.7628 0.638047 21.4318 0.308047C21.1018 -0.0219531 20.566 -0.0219531 20.236 0.308047L10.8539 9.68988L1.47187 0.308047C1.14187 -0.0219531 0.60682 -0.0219531 0.27582 0.308047C-0.0541797 0.638047 -0.0541797 1.17385 0.27582 1.50385L9.6579 10.8859L0.27582 20.268C-0.0541797 20.598 -0.0541797 21.1341 0.27582 21.4641C0.44182 21.6291 0.657941 21.7119 0.874941 21.7119C1.09094 21.7119 1.30684 21.6291 1.47284 21.4641L10.8539 12.082L20.236 21.4641C20.401 21.6291 20.6179 21.7119 20.8339 21.7119C21.0509 21.7119 21.2668 21.6291 21.4318 21.4641C21.7628 21.1341 21.7628 20.598 21.4318 20.268L12.051 10.8859Z"
});

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.d02ec259.svg";
export { ForwardRef as ReactComponent };